<template>
    <!--电梯弹窗-->
    <div class="elevator-box" id="elevator">
      <div class="elevator-title">
        <img src="./../assets/elevator-ico.png">
        <span>
          电梯监控
        </span>
        <div class="san"></div>
        <p>1号电梯</p>
        <div class="close"></div>
      </div>
      <div class="elevator-content">
        <P>
          <span>荷载人数：</span>
          <span>20人</span>
        </P>
        <P>
          <span>当前人数：</span>
          <span>10人</span>
        </P>
      </div>
    </div>
</template>

<script>
    export default {
        name: "Elevator"
    }
</script>

<style scoped lang="less">
  .elevator-box{
    position: absolute;
    top: 0;
    left: 200px;
    background: url("./../assets/elevator-box.png") no-repeat;
    background-size: 100% 100%;
    width: 350px;/*no*/
    height: 219px;/*no*/
    z-index: 999;
    .elevator-content{
      position: absolute;
      width: 100%;
      display: flex;
      box-sizing: border-box;
      bottom: 12px;/*no*/
      font-size: 14px;
      font-family: "Microsoft YaHei";
      color: rgb(255, 255, 255);
      padding-left: 30px;/*no*/
      p{
        &:nth-of-type(1){
          margin-right: 64px;/*no*/
        }
      }
    }
    .close{
      width: 10px;
      height: 10px;
      background: url("./../assets/close.png") no-repeat;
      background-size: 100% 100%;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 9px;
      cursor: pointer;
      z-index: 999;
    }
    .elevator-title{
      position: relative;
      background: url("./../assets/elevator-title.png") no-repeat;
      background-size: 100% 100%;
      width: 350px;/*no*/
      height: 39px;/*no*/
      padding-left: 20px;/*no*/
      box-sizing: border-box;
      display: flex;
      align-items: center;
      font-family: "Microsoft YaHei";
      color: rgb(255, 255, 255);
      span{
        margin-left: 10px;/*no*/
      }
      .san{
        background: url("./../assets/elevator-san.png") no-repeat;
        width: 12px;/*no*/
        height: 8px;/*no*/
        background-size: 100% 100%;
        margin-left: 5px;/*no*/
      }
      p{
        margin-left: 26px;
        font-size: 14px;
        font-family: "Microsoft YaHei";
        color: rgb(255, 162, 0);

      }
    }
  }
</style>
